import axios from "../../axiosInstance";
import requests from '../../requests';

import { takeLatest, all, put, call, delay } from "redux-saga/effects";

import { mainActionTypes } from "./main.types";
import {
	fetchDiagramSuccessMain,
	fetchDiagramFailureMain,

	sendFeedbackSuccess,
	sendFeedbackFailure,
} from "./main.actions";

import { showNotify } from "../notify/notify.actions";


export function* fetchDiagramRequest({ payload: { diagramId } }) {
	try {
		// const url = `${requests.diagrams}/${diagramId}`;
		const url = `${requests.diagrams}/default`;

		const { data, error } = yield axios.get(url, {});
		if (error) {
			yield put(fetchDiagramFailureMain(error));
			yield put(showNotify({ message: 'something_wrong' }));
		} else {
			yield put(fetchDiagramSuccessMain(data));
		}
	} catch (e) {
		// yield put(fetchDiagramFailureMain(e));
		// yield put(showNotify({ message: 'something_wrong' }));

		yield delay(500);
		const testData = {
			id: 'default',
			title: 'Delivery App (Uber Eats like)',
			description: 'Project X is a fictional experimental database focused on tracking anomalies and scientific experiments. Ideal for showcasing advanced data modeling concepts like enums, JSON fields, and complex relationships.',
			db_engine: 'postgresql',
			data: {
				scale: 2,
				originXY: { x: 0, y: 0 },
				elements: {},
				lines: {},
				areas: {},
				// canvasLimits: {},
			}
		};
		yield put(fetchDiagramSuccessMain(testData));
	}
}

export function* sendFeedbackRequest({ payload: { data: body } }) {
	try {
		yield put(showNotify({ message: 'sending' }));
		const url = `${requests.sendFeedback}`;
		const { data, error } = yield axios.post(url, body);
		if (error) {
			yield put(sendFeedbackFailure(error));
			yield put(showNotify({ message: 'something_wrong' }));
		} else {
			yield put(sendFeedbackSuccess());
			yield put(showNotify({ message: 'request_sent' }));
		}
	} catch (e) {
		yield put(sendFeedbackSuccess());
		yield put(showNotify({ message: 'request_sent' }));
		// yield put(sendFeedbackFailure(e));
		// yield put(showNotify({ message: 'something_wrong' }));
	}
}

export function* onFetchDiagram() {
	yield takeLatest(mainActionTypes.MAIN_FETCH_DIAGRAM_REQUEST, fetchDiagramRequest);
}

export function* onSendFeedback() {
	yield takeLatest(mainActionTypes.SUPPORT_REQ_REQUEST, sendFeedbackRequest);
}

export function* mainSagas() {
	yield all
		([
			call(onFetchDiagram),
			call(onSendFeedback),
		]);
}